import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    overflowX: 'auto',
    height: '100%',
    padding: '0 0.5rem',

    [theme.breakpoints.down('md')]: {
      alignItems: 'flex-start'
    }
  }
}))

export default useStyles
